/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Odd_Tame_Stingray_VentInputs */

const fr_odd_tame_stingray_vent = /** @type {(inputs: Odd_Tame_Stingray_VentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min (m)`)
};

/**

* @param {Odd_Tame_Stingray_VentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const odd_tame_stingray_vent = /** @type {((inputs?: Odd_Tame_Stingray_VentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Odd_Tame_Stingray_VentInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_odd_tame_stingray_vent(inputs)
});